import { FormattedMessage } from "react-intl";

export function NoProductsLeftLabel() {
  return (
    <FormattedMessage
      defaultMessage="No products left"
      description="ProductExpireBatch no products left label"
    />
  );
}
